import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateLogisticPieceRangeInput,
    LogisticPieceRange,
    UpdateLogisticPieceRangeInput,
    DeleteLogisticPieceRangeInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class LogisticPieceRangeService {
    private amplifyClient = generateClient();
    constructor() {}

    async getLogisticPieceRange(id: string): Promise<LogisticPieceRange> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getLogisticPieceRange,
                    variables: {
                        id
                    }
                })
            ).data.getLogisticPieceRange;
            if (data) return data as LogisticPieceRange;
        } catch (error) {
            console.error('Error finding LogisticPieceRange:', error);
            return null;
        }
    }

    async listLogisticPieceRanges(): Promise<LogisticPieceRange[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listLogisticPieceRanges
                })
            ).data.listLogisticPieceRanges.items;
            if (data) return data as LogisticPieceRange[];
        } catch (error) {
            console.error('Error finding LogisticPieceRange:', error);
            return null;
        }
    }

    async listAllLogisticPieceRanges(
        pageLimit: number = 100
    ): Promise<LogisticPieceRange[]> {
        const ranges: LogisticPieceRange[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listLogisticPieceRanges,
                        variables: {
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.listLogisticPieceRanges;
                ranges.push(
                    ...((response?.items ?? []) as LogisticPieceRange[])
                );
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return ranges;
        } catch (error) {
            console.error('Error finding LogisticPieceRange:', error);
            return [];
        }
    }

    async createLogisticPieceRange(
        input: CreateLogisticPieceRangeInput
    ): Promise<LogisticPieceRange> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createLogisticPieceRange,
                    variables: {
                        input
                    }
                })
            ).data.createLogisticPieceRange;
            if (date) return date as LogisticPieceRange;
        } catch (error) {
            console.error('Error creating LogisticPostalCode:', error);
            return null;
        }
    }
    async updateLogisticPostalCode(
        input: UpdateLogisticPieceRangeInput
    ): Promise<LogisticPieceRange> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateLogisticPieceRange,
                    variables: {
                        input
                    }
                })
            ).data.updateLogisticPieceRange;
            if (date) return date as LogisticPieceRange;
        } catch (error) {
            console.error('Error update LogisticPieceRange:', error);
            return null;
        }
    }

    async deleteLogisticPieceRange(
        input: DeleteLogisticPieceRangeInput
    ): Promise<LogisticPieceRange> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteLogisticPieceRange,
                    variables: {
                        input
                    }
                })
            ).data.deleteLogisticPieceRange;
            if (date) return date as LogisticPieceRange;
        } catch (error) {
            console.error('Error delete LogisticPieceRange:', error);
            return null;
        }
    }
}
